import i18n from "i18next";
import { faShareSquare } from "@fortawesome/pro-regular-svg-icons";
import { useTenantCustomizations } from "src/tenantCustomizations/TenantCustomizationsContext.ts";
import { AsyncButton, AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { CustomersView } from "src/components/views/erp/sales/customer/CustomersView.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface OpenCustomerButtonProps extends Omit<AsyncButtonProps, "onClick"> {
	customerId: number;
}

export const OpenCustomerButton = ({ customerId, variant = "menu" }: OpenCustomerButtonProps) => {
	const { openDialog } = useGenericDialog();

	const { tenantConfig } = useTenantCustomizations();
	if (!tenantConfig.erp.salesEnabled) return null;

	return (
		<AsyncButton
			label={i18n.t("customer")}
			icon={faShareSquare}
			variant={variant}
			onClick={() => {
				openDialog({
					title: i18n.t("customer"),
					agentContext: {
						key: defineAgentUiContextKey("erp.sales.customer.openCustomerButton.dialog"),
						data: { customerId },
						pathSegments: [`${i18n.t("customer")} ${customerId}`],
					},
					content: <CustomersView onlyCustomerToShowId={customerId} />,
				});
			}}
		/>
	);
};
